VP = window.VP || {};

(function( $ ) {
	VP.resourceModule = {
		init: function () {
			var _this = this;

			_this.showResources();
			
			return false;
		},

		showResources: function() {
			var _this = this;
			
			var button = $('.vp-resource-module__view-all');
			var resourceBody = $('.vp-resource-module__body');

			button.click( function ( e ) {
				e.preventDefault();
				resourceBody.slideDown();
				button.hide();
			} );
		},
	};
})(jQuery);
